export default __webpack_public_path__ + "static/media/14c.16983346.svg";